import { useEffect, useState, memo } from 'react';
import '../estilos/StyHome.css';
import ImagenAnimada from '../componentes/ImgAnimacion';
import Navega from '../componentes/Nav';
import { Link, useNavigate } from 'react-router-dom';
import Footer from '../componentes/footer';
import { useTranslation } from 'react-i18next';
import { getTours } from '../api/tours';
import CarruselDestacados from '../componentes/Carruseldestacados';

const SLUGS_DESTACADOS = [
  'pesca-deportiva-guanacaste',
  'mega-combo-guanacaste',
  'gira-10-dias-costa-rica',
  'tour-perezosos-cataratas-rio-celeste',
];

const SUBTITULOS = [
  'Every trip becomes an unforgettable story',
  'Explore places full of history and authenticity',
  'Waterfalls · Rio Celeste · Hike · Chocolate Tour',
];
const SUBTITULOS_ES = [
  'Donde cada viaje se convierte en una historia inolvidable',
  'Explora lugares llenos de historia y autenticidad',
  'Cataratas · Rio Celeste · Caminata · Tour de chocolate',
];

const TRIPADVISOR_URL =
  'https://www.tripadvisor.com/Attraction_Review-g309240-d34317655-Reviews-Pacific_Tour_Cr-Liberia_Province_of_Guanacaste.html';

const BannerCard = memo(({ tour, numero, subtitulo, esIngles }) => (
  <div className="banner-card">
    <img src={tour.image} alt={esIngles ? tour.title_en : tour.title} loading="lazy" />
    <div className="banner-overlay">
      <div className="banner-top-row">
        <span className="banner-number">{String(numero).padStart(2, '0')}</span>
        <span className="banner-tag">{esIngles ? tour.category_en : tour.category}</span>
      </div>
      <h3>{esIngles ? tour.title_en : tour.title}</h3>
      <p>{subtitulo}</p>
      <Link to={`/experiencia/${tour.slug}`} className="banner-link">
        {esIngles ? 'View details' : 'Ver detalles'}
      </Link>
    </div>
  </div>
));

const BannerSkeleton = () => (
  <div className="banner-card" style={{ background: '#e8f0ec', minHeight: 320, borderRadius: 16, animation: 'pulse 1.5s ease-in-out infinite' }} />
);

const TripShowcase = memo(({ esIngles }) => (
  <a 
    href={TRIPADVISOR_URL}
    target="_blank"
    rel="noopener noreferrer"
    className="trip-showcase"
    aria-label={esIngles ? 'See our reviews on Tripadvisor' : 'Ver nuestras opiniones en Tripadvisor'}
  >
    <div className="trip-showcase-left">
      <img
        src="https://cdn.simpleicons.org/tripadvisor/2d6a4f"
        alt="Tripadvisor"
        className="trip-showcase-logo"
        width="38"
        height="38"
        loading="lazy"
      />
      <div className="trip-showcase-text">
        <span className="trip-showcase-score">5,0</span>
        <span className="trip-showcase-bubbles" aria-hidden="true">
          {[1,2,3,4,5].map(n => <span key={n} className="trip-showcase-bubble" />)}
        </span>
        <span className="trip-showcase-label">
          {esIngles ? 'Verified by travelers' : 'Verificado por viajeros'}
        </span>
      </div>
    </div>
    <div className="trip-showcase-badge">
      <span className="trip-showcase-badge-icon">✦</span>
      <span className="trip-showcase-badge-text">
        {esIngles ? 'Travelers\' Choice' : 'Elección de Viajeros'}
      </span>
    </div>
    <span className="trip-showcase-cta">
      {esIngles ? 'See reviews' : 'Ver opiniones'} →
    </span>
  </a>
));

function Home() {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const esIngles = i18n.language === 'en';

  const [tours, setTours] = useState([]);
  const [cargando, setCargando] = useState(true);

  useEffect(() => {
    let cancelled = false;
    getTours()
      .then(data => { if (!cancelled) { setTours(data); setCargando(false); } })
      .catch(() => { if (!cancelled) setCargando(false); });
    return () => { cancelled = true; };
  }, []);

  const destacados = SLUGS_DESTACADOS.map(s => tours.find(t => t.slug === s));

  return (
    <>
      <Navega />

      <section className="Hero">
        <ImagenAnimada />
      </section>

      <section className="Content">
        <div className="content-header">
          <h1>{t('home_titulo')}</h1>
          <h2>{t('home_subtitulo')}</h2>
          <p>
            {esIngles
              ? 'Authentic nature experiences designed for curious travelers'
              : 'Experiencias auténticas en la naturaleza diseñadas para viajeros curiosos'}
          </p>
        </div>

        <div className="stats-bar">
          <div className="stat-item">
            <span className="stat-number">{cargando ? '—' : tours.length}</span>
            <span className="stat-label">{esIngles ? 'Experiences' : 'Experiencias'}</span>
          </div>
          <div className="stat-item">
            <span className="stat-number">100%</span>
            <span className="stat-label">{esIngles ? 'Nature & local' : 'Natural y local'}</span>
          </div>
          <div className="stat-item">
            <span className="stat-number">CR</span>
            <span className="stat-label">Costa Rica</span>
          </div>
        </div>

        <TripShowcase esIngles={esIngles} />

        <div className="tours-section">
          <p className="tours-label">
            {esIngles ? 'Featured experiences' : 'Experiencias destacadas'}
          </p>

          {cargando
            ? SLUGS_DESTACADOS.map((_, i) => <BannerSkeleton key={i} />)
            : destacados.map((tour, i) =>
                tour ? (
                  <BannerCard
                    key={tour.slug}
                    tour={tour}
                    numero={i + 1}
                    subtitulo={esIngles ? SUBTITULOS[i] : SUBTITULOS_ES[i]}
                    esIngles={esIngles}
                  />
                ) : null
              )
          }
        </div>

        <div className="more-experience">
          <p>{esIngles ? 'Discover all our experiences' : 'Descubre todas nuestras experiencias'}</p>
          <button className="btn-tourism" onClick={() => navigate('/AllExperiencia')}>
            {t('home_btn_mas')}
          </button>
        </div>
      </section>

      <CarruselDestacados />
      <Footer />
    </>
  );
}

export default Home;